import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "bank-account" + (_vm.wallet ? "-wallet" : "")
    }
  }, [_vm.value === 0 ? _c("div", {
    staticClass: "new-bank"
  }, [_c("form", [_c("div", [_vm._v("IBAN")]), _c("div", {
    staticClass: "new-bank-container",
    attrs: {
      id: "bank-account-element"
    }
  }), _vm.errorMessage ? _c("div", {
    staticClass: "errorLabel",
    attrs: {
      role: "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e(), _c(VCheckbox, {
    staticClass: "mb-4",
    attrs: {
      label: "Save the bank account for later payment",
      "hide-details": "auto"
    },
    model: {
      value: _vm.savePaymentForLater,
      callback: function callback($$v) {
        _vm.savePaymentForLater = $$v;
      },
      expression: "savePaymentForLater"
    }
  })], 1), _vm.wallet ? _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveBankAccount(true);
      },
      shortkey: function shortkey($event) {
        return _vm.saveBankAccount(true);
      }
    }
  }, [_vm._v(" Save ")]) : _vm._e()], 1) : _vm._e(), _vm.wallet || _vm.value > 0 ? _c("div", {
    staticClass: "saved-bank"
  }, [_vm._m(0), _c("div", {
    staticClass: "saved-bank-title"
  }, [_vm._v("Saved bank account")]), _c("div", {
    staticClass: "saved-bank-first-line"
  }, [_vm._v(" " + _vm._s(_vm.value.country || _vm.value.routing_number) + "XX" + _vm._s(_vm.value.bank_name) + "XXXXXX" + _vm._s(_vm.value.last4) + " ")]), _c("div", {
    staticClass: "saved-bank-buttons"
  }, [_vm.wallet ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.deleteBankAccount();
      },
      shortkey: function shortkey($event) {
        return _vm.deleteBankAccount();
      }
    }
  }, [_vm._v(" Delete ")]) : _vm._e()], 1)]) : _vm._e(), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "saved-bank-icon"
  }, [_c("i", {
    staticClass: "fas fa-landmark"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };